import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  headers: {
    'Accept': 'application/json',
    'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    'X-Zenky-Version': process.env.VUE_APP_API_BUILD_VERSION || 'not_specified',
    'X-Zenky-Client': 'mobile_cashier',
  },
})

export default instance
